import React from "react";
import Trait1 from "../traitCard/trait1/trait1";
import traitCardImg1 from "../../assets/traitCardImg1.png";
import traitCardImg2 from "../../assets/traitCardImg2.png";
import traitCardImg3 from "../../assets/traitCardImg3.png";
import traitCardImg4 from "../../assets/traitCardImg4.svg";
import traitCardImg5 from "../../assets/traitCardImg5.png";
import traitCardImg6 from "../../assets/traitCardImg6.png";
import traitCardImg7 from "../../assets/traitCardImg7.png";
import traitCardImg8 from "../../assets/traitCardImg8.png";
import traitCardImg9 from "../../assets/traitCardImg9.png";
import Slider from "../../components/Slider/Slider";
import "./fourthSection.css";
import MobileSlider from "../../mobileSlider/mobileSlider";

const FourthSection = () => {
  return (
    <div className="fourthSection-main-wrapper">
      <div className="fourthSection-inner-container">
        <div>
          <h1 className="fourthSection-Heading mypc">TRAIT CATEGORIES</h1>
          <div className="trait-container mypc">
            <div className="trait-row">
              <Trait1
                traitValue={"08"}
                traitTitle={"Legendary traits"}
                traitCardImg={traitCardImg1}
                bgColor={"#FAD867"}
              />
              <Trait1
                traitValue={"08"}
                traitTitle={"Piercings"}
                traitCardImg={traitCardImg2}
                bgColor={"#A1BFDD"}
              />
              <Trait1
                traitValue={"45"}
                traitTitle={"Clothes"}
                traitCardImg={traitCardImg3}
                bgColor={"#BEA2FD"}
              />
            </div>
            <div className="trait-row">
              <Trait1
                traitValue={"07"}
                traitTitle={"Backgrounds"}
                traitCardImg={traitCardImg4}
                bgColor={"#BFDDB6"}
              />
              <Trait1
                traitValue={"07"}
                traitTitle={"Eyes"}
                traitCardImg={traitCardImg5}
                bgColor={"#FFAB91"}
              />
              <Trait1
                traitValue={"33"}
                traitTitle={"Mouths"}
                traitCardImg={traitCardImg6}
                bgColor={"#BFDDB6"}
              />
            </div>
            <div className="trait-row">
              <Trait1
                traitValue={"15"}
                traitTitle={"Shells"}
                traitCardImg={traitCardImg7}
                bgColor={"#A1BFDD"}
              />
              <Trait1
                traitValue={"35"}
                traitTitle={"Hats"}
                traitCardImg={traitCardImg8}
                bgColor={"#BEA2FD"}
              />
              <Trait1
                traitValue={"20"}
                traitTitle={"Glasses"}
                traitCardImg={traitCardImg9}
                bgColor={"#FAD867"}
              />
            </div>
          </div>
          {/* Mobile View Start*/}
          <div className="mymob">
            {/* <Slider /> */}
            <MobileSlider numberOfSlides={1} title="TRAIT CATEGORIES">
              <div>
                <Trait1
                  traitValue={"08"}
                  traitTitle={"Legendary traits"}
                  traitCardImg={traitCardImg1}
                  bgColor={"#FAD867"}
                />
              </div>
              <div>
                <Trait1
                  traitValue={"08"}
                  traitTitle={"Piercings"}
                  traitCardImg={traitCardImg2}
                  bgColor={"#A1BFDD"}
                />
              </div>
              <div>
                <Trait1
                  traitValue={"45"}
                  traitTitle={"Clothes"}
                  traitCardImg={traitCardImg3}
                  bgColor={"#BEA2FD"}
                />
              </div>
              <div>
                <Trait1
                  traitValue={"07"}
                  traitTitle={"Backgrounds"}
                  traitCardImg={traitCardImg4}
                  bgColor={"#BFDDB6"}
                />
              </div>
              <div>
                <Trait1
                  traitValue={"07"}
                  traitTitle={"Eyes"}
                  traitCardImg={traitCardImg5}
                  bgColor={"#FFAB91"}
                />
              </div>
              <div>
                <Trait1
                  traitValue={"33"}
                  traitTitle={"Mouths"}
                  traitCardImg={traitCardImg6}
                  bgColor={"#BFDDB6"}
                />
              </div>
              <div>
                <Trait1
                  traitValue={"15"}
                  traitTitle={"Shells"}
                  traitCardImg={traitCardImg7}
                  bgColor={"#A1BFDD"}
                />
              </div>
              <div>
                <Trait1
                  traitValue={"35"}
                  traitTitle={"Hats"}
                  traitCardImg={traitCardImg8}
                  bgColor={"#BEA2FD"}
                />
              </div>
              <div>
                <Trait1
                  traitValue={"20"}
                  traitTitle={"Glasses"}
                  traitCardImg={traitCardImg9}
                  bgColor={"#FAD867"}
                />
              </div>
            </MobileSlider>
            <p style={{color: '#FFFFFF', padding: '20px', width:'85%' , fontFamily:'Sansita Swashed', fontSize:'15px', letterSpacing:'1px'}}>
              Note: Twenty five potatoes are being withheld from the sale and be
              used for PPC creators memberships, giveaways, partnerships, and
              rewards.
            </p>
          </div>
          {/* Mobile View End*/}
        </div>
      </div>
    </div>
  );
};

export default FourthSection;
